export default {
    auth: {
        foreigner_wrapper: "I'm a foreigner",
    },
    login: {
        title_wrapper: {
            title: 'Access your account',
            description: 'Welcome back! Log in with your details.',
        },
        text_inputs_wrapper: {
            input_item: {
                cpf_label: 'Passport',
                cpf_placeholder: 'Enter your passport',
                password_label: 'Password',
                password_placeholder: 'Enter your password',
                forgot_password: 'Forgot your password?',
            },
        },
        error_column: {
            api_error: '{{errorMessage}}',
        },
        big_button: {
            submit_text: 'Log In',
        },
        create_account_notice: {
            text: "Don't have an account yet?",
            link_text: 'Create an account',
        },
        maintenance: {
            title: 'Maintenance in progress',
            summary:
                'Sign-in is temporarily unavailable while we roll out updates.',
            toast_full:
                'We are in the final phase of releasing the hotel reservation calendar.\nThe store will be available in the next few hours with the new features.\nThank you for your understanding.',
        },
    },
    reset_password: {
        title_wrapper: {
            title: 'Recover password',
            description: 'Enter your document to proceed.',
        },
        text_inputs_wrapper: {
            input_item: {
                cpf_label: 'Passport',
                cpf_placeholder: 'Enter your passport',
            },
        },
        error_column: {
            api_error: '{{errorMessage}}',
        },
        big_button: {
            submit_text: 'Confirm',
        },
        create_account_notice: {
            text: 'Already have an account?',
            link_text: 'Log In',
        },
    },
    create_account: {
        title_wrapper: {
            title: 'Create your account',
            description: 'Enter your details to complete the registration.',
        },
        text_inputs_wrapper: {
            name_label: 'Name',
            name_placeholder: 'Enter your name',
            bornDate_label: 'Date of birth',
            bornDate_placeholder: '00/00/0000',
            email_label: 'Email',
            email_placeholder: 'Enter your email',
            cpf_label: 'Passport',
            cpf_placeholder: 'Enter your passport',
            phone_label: 'Phone',
            phone_placeholder: 'Enter your phone',
            password_label: 'Password',
            password_placeholder: 'Enter your password',
            confirm_password_label: 'Confirm password',
            confirm_password_placeholder: 'Enter your password',
            cep_label: "Postal code",
            address_label: "Address",
            cep_placeholder: "Enter your postal code",
        },
        error_column: {
            api_error: '{{errorMessage}}',
        },
        big_button: {
            submit_text: 'Register',
        },
        create_account_notice: {
            text: 'Already have an account?',
            link_text: 'Log In',
        },
    },
    check_email_confirmation: {
        title_wrapper: {
            title: 'Check your email!',
            description: 'We sent instructions for password recovery.',
        },
        big_button: {
            submit_text: 'Back to login',
        },
    },
};
